export default __webpack_public_path__ + "static/media/3.db494e0e.png";